<template>
  <div
    class="-mx-12 p-12 flex flex-col flex-wrap justify-between border-t border-purple-ap-t03"
  >
    <h2 class="font-semibold text-purple-ap-100">
      Additional Notes for Host Families
    </h2>

    <div class="mt-5">
      <p>{{ notes }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FullNotoesForHostFamily",
  props: {
    notes: String,
  },
};
</script>

<style></style>
